import { CARD, BOLETO } from './constants'

export const getPaymentMethod = reservation => {
    switch (reservation.paymentMode) {
        case 'BOLETO':
            return BOLETO
        case 'DEBIT':
        case 'CREDIT':
        default:
            return CARD
    }
}
